import { getLocale } from "../runtime";

const sv_easteregg3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Dags för en snabb stretch? Ditt välmående är viktigt även när sidor inte laddar.`
};

const easteregg3 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_easteregg3(inputs)
	return "easterEgg3";
};

export { easteregg3 as "easterEgg3" };